import { useContext } from 'react';
import { I18nContext, type I18nContextValue } from './context';

/**
 * Reads the active locale and `t()` translator. Works with or without a
 * mounted `<LocaleProvider>` (see `defaultContextValue` in `context.ts`), so
 * it is always safe to call from any component, including in isolated unit
 * tests.
 */
export function useI18n(): I18nContextValue {
    return useContext(I18nContext);
}
